import Vue from 'vue'
import VueLuxon from 'vue-luxon'

Vue.use(VueLuxon, {
  serverZone: 'America/New_York',
  serverFormat: 'sql'
})
